<nav class="navbar navbar-expand-lg navbar-landing fixed-top" id="navbar" [ngClass]="{ 'white-background': isScrolled }">
  <div class="container">
    <a class="navbar-brand" routerLink="/" (click)="route_home()">
      <img src="assets/images/svg/figma2.png" class="card-logo card-logo-dark" alt="logo dark" height="">
      <!-- <img src="assets/images/svg/figma2.png" class="card-logo card-logo-light" alt="logo light" height=""> -->
    </a>
    <button class="navbar-toggler py-0 fs-20 text-body" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleMenu()">
      <i class="mdi mdi-menu"></i>
    </button>

    <div #navbarContent class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mx-auto mt-2 mt-lg-0" id="navbar-example">
        <!-- <li class="nav-item">
                    <a class="nav-link"  href="javascript:void(0);">Products</a>
                </li> -->
        <!-- <div class="col">
          <div ngbDropdown class="d-inline-block  nav-link" #deviceDrop="ngbDropdown">
            <a id="dropdownBasic1" ngbDropdownToggle style="color:black; cursor: pointer; font-weight: 500; font-size: 14px!important;" (mouseenter)="deviceDrop.open(); openDropdownMenu('products')" id="nav4" (click)="onClick11()">
              Products
            </a>
            <ul ngbDropdownMenu aria-labelledby="dropdownBasic1" id="dropdown11" (mouseleave)="$event.stopPropagation(); deviceDrop.close(); closeDropdown()" [ngClass]="{'show': openDropdown === 'products'}">
              <li class="mt-2">
                       <a ngbDropdownItem style="cursor: pointer; display: block;" id="data">
                         <div class="row">
                           <div class="col-4 ooo d-flex" *ngFor="let product of productsList; let i = index">
                             <div class="me-2">
                               <img src="assets/images/svg/h11.svg" width="20px">
                             </div>
                             <div>
                               <p class="main-heading">{{ product.name }}</p>
                               <p class="sub-heading">{{ product.test }}</p>
                             </div>
                             
                           </div>
                         </div>
                       </a>
                     </li>
              <li class="mt-2">
                <a ngbDropdownItem style="cursor: pointer; display: block;" id="data">
                  <div class="row">
                    <div class="col-4 ooo d-flex" *ngFor="let product of productsList1; let i = index">
                      <div class="me-2">
                        <img src="assets/images/svg/h11.svg" width="20px">
                      </div>
                      <div>
                        <p class="main-heading">{{ product.name }}</p>
                        <p class="sub-heading">{{ product.test }}</p>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
              <li class="mt-2">
                <a ngbDropdownItem style="cursor: pointer; display: block;" id="data">
                  <div class="row">
                    <div class="col-4 ooo d-flex" *ngFor="let product of productsList2; let i = index">
                      <div class="me-2">
                        <img src="assets/images/svg/h11.svg" width="20px">
                      </div>
                      <div>
                        <p class="main-heading">{{ product.name }}</p>
                        <p class="sub-heading">{{ product.test }}</p>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div> -->
        <div class="col">
          <div class="d-inline-block  nav-link">
            <a id="dropdownBasic2" style="color:black; cursor: pointer; font-weight: 500; font-size: 14px!important;" id="nav4" (click)="onClick2()">
              Services
            </a>
            <!-- <ul ngbDropdownMenu aria-labelledby="dropdownBasic2" id="dropdown11" (mouseleave)="$event.stopPropagation(); deviceDrop1.close(); closeDropdown()" [ngClass]="{'show': openDropdown === 'services'}">
              <li class="mt-2">
                <a ngbDropdownItem style="cursor: pointer; display: block;" id="data">
                  <div class="row">
                    <div class="col-4 ooo d-flex" *ngFor="let product of serviceList; let i = index">
                      <div class="me-2">
                        <img src="assets/images/svg/h11.svg" width="20px">
                      </div>
                      <div>
                        <p class="main-heading">{{ product.name }}</p>
                        <p class="sub-heading">{{ product.test }}</p>
                      </div>

                    </div>
                  </div>
                </a>
              </li>
              <li class="mt-2">
                <a ngbDropdownItem style="cursor: pointer; display: block;" id="data">
                  <div class="row">
                    <div class="col-4 ooo d-flex" *ngFor="let product of serviceList1; let i = index">
                      <div class="me-2">
                        <img src="assets/images/svg/h11.svg" width="20px">
                      </div>
                      <div>
                        <p class="main-heading">{{ product.name }}</p>
                        <p class="sub-heading">{{ product.test }}</p>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul> -->
          </div>
        </div>
        <li class="nav-item">
          <a class="nav-link" href="javascript:void(0);" (click)="onClick()">Track Orders</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="javascript:void(0);" (click)="onClick3()">Retail Care Plans</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="javascript:void(0);" (click)="onClick4()">Get A Demo</a>
        </li>
        <!-- <div class="col">
          <div ngbDropdown class="d-inline-block  nav-link" #deviceDrop3="ngbDropdown">
            <a id="dropdownBasic4" ngbDropdownToggle style="color:black; cursor: pointer; font-weight: 500; font-size: 14px!important;" (mouseenter)="deviceDrop3.open(); openDropdownMenu('partners')" id="nav4" (click)="onClick5()">
              Partners
            </a> 
          </div>
        </div> -->

      </ul>
      <div class="d-flex">
        <a (click)="route()" class="btn btn-link fw-medium text-decoration-none text-dark" style="color: white!important;background: #0b4444;border: 0b4444 0px soild;">Sign
          in</a>
        <!-- <a routerLink="/signup/basic" class="btn btn signup">Sign Up</a> -->
      </div>
    </div>

  </div>
</nav>